import React, { useState } from 'react';
import { IconHelpFilled } from '../icons/help-filled';
import { PositionType } from '../../../utils/calculate-position';
import { FloatingObject } from '../floating-object/floating-object';
import { cn } from '../../../utils/tailwind';

type TooltipProps = {
    children: React.ReactNode;
    content?: React.ReactNode | string;
    position?: PositionType;
    size?: 'small' | 'medium' | 'large';
    icon?: boolean;
    arrowPosition?: number;
    block?: boolean;
    cursor?: boolean;
};

export const Tooltip: React.FC<TooltipProps> = ({
    children,
    content,
    position = 'top-left',
    size = 'medium',
    icon = false,
    arrowPosition,
    block = false,
}) => {
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    const contentClassName = cn(
        'max-w-[30rem] rounded-[0.8rem] bg-brand-secondary px-[1rem] py-[0.8rem] text-center text-text-inverse normal-case shadow-[0_0_0.6rem_0.2rem_rgba(0,0,0,0.3)]',
        size === 'medium' && 'p-[1.6rem] text-small leading-[2rem]',
        size === 'large' && 'p-[2rem] text-large leading-[2.6rem]',
    );

    return content ? (
        <FloatingObject
            trigger={children}
            content={<div className={contentClassName}>{content}</div>}
            position={position}
            isVisible={isTooltipVisible}
            setIsVisible={setIsTooltipVisible}
            arrowPosition={arrowPosition}
            block={block}
            icon={
                icon && (
                    <span className="relative inline-flex text-inherit [&_i]:h-[1.4rem] [&_i]:w-[1.4rem]">
                        <IconHelpFilled />
                    </span>
                )
            }
            cursor={icon}
            size={size}
            arrowColor="secondary"
        />
    ) : (
        <>{children}</>
    );
};
